import { CROPPABLE_IMAGE_MIME_TYPES } from './ImageCropModal';

const CROPPABLE_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'];

export const isCroppableImageSource = (source: string) => {
  if (source.startsWith('blob:')) {
    return true;
  }

  if (source.startsWith('data:')) {
    const mimeType = source.split(':')[1]?.split(';')[0];

    return Boolean(mimeType && CROPPABLE_IMAGE_MIME_TYPES.includes(mimeType));
  }

  const extension = source.split('?')[0].split('.').pop()?.toLowerCase();

  return Boolean(extension && CROPPABLE_IMAGE_EXTENSIONS.includes(extension));
};
